/**
 * Access control utilities for the POS system
 */

/**
 * Check if a user has access to analytics
 * @param {Object} user - The user object
 * @returns {boolean} - True if user has access to analytics
 */
export const hasAnalyticsAccess = (user) => {
  if (!user) return false;
  
  // Admin users always have access
  if (user.is_admin) return true;
  
  // Specific user IDs that have access (you can modify this list)
  const allowedUserIds = [1, 2]; // Admin (1) and Manager (2)
  
  return allowedUserIds.includes(user.id);
};

/**
 * Check if a user has admin privileges
 * @param {Object} user - The user object
 * @returns {boolean} - True if user is admin
 */
export const isAdmin = (user) => {
  return user && user.is_admin === true;
};

/**
 * Check if a user has cashier privileges
 * @param {Object} user - The user object
 * @returns {boolean} - True if user is cashier (not admin)
 */
export const isCashier = (user) => {
  return user && user.is_admin === false;
};

/**
 * Reports: managers and admins may list, run and export saved reports.
 * Mirrors the backend's require_report_viewer (user ids 1, 2 or is_admin).
 */
export const hasReportsAccess = (user) => {
  return !!user && (user.is_admin === true || user.id === 1 || user.id === 2);
};

/**
 * Reports: only admins create, edit or delete report definitions and use the SQL workbench.
 * Mirrors the backend's require_report_admin (user id 1 or is_admin).
 */
export const canManageReports = (user) => {
  return !!user && (user.is_admin === true || user.id === 1);
};
